var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 62,
    viewBox: "0 0 71 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6889 11.0286C9.59487 12.6361 8.14667 15.8384 6.79355 19.1046C5.44368 22.3455 4.17937 25.6438 3.818 27.537C3.51503 29.0146 4.28977 30.1003 5.83135 30.6815L50.3573 49.2214C52.3585 50.0839 54.2646 50.8826 55.2199 51.0836C57.343 51.5182 58.9883 51.4111 59.7502 50.4211C61.1816 48.5993 62.6731 45.7843 63.8791 42.8602C65.0946 39.9425 66.0469 36.9031 66.327 34.5969C66.4863 33.3535 65.3913 32.1078 63.588 30.9097C62.7735 30.3761 60.8674 29.5775 58.8438 28.7688L14.3179 10.2289C12.8242 9.55581 11.5216 9.76908 10.6794 11.0222L10.6889 11.0286Z",
    fill: "#2E8F1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4585 46.8388L37.8164 43.1776C36.8429 42.7163 36.3712 42.2477 36.4068 42.0098L36.5043 41.2898C36.5238 41.1375 37.0474 41.2414 37.7674 41.5461L39.277 42.1748C40.9136 42.8611 42.2296 43.4699 43.1393 44.0262L46.0523 45.7909C46.6895 46.1777 47.1108 46.516 47.0372 46.687L46.7974 47.2287C46.7527 47.3364 46.0166 47.1173 45.4521 46.8483L45.4585 46.8388Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6354 43.8113L42.64 45.4268L37.8486 43.1301C37.503 42.9667 37.1765 42.7749 36.8755 42.5451C36.3496 42.1365 36.4738 42.0133 36.5744 41.3091C36.6255 41.1919 37.5201 41.5037 37.628 41.5486C39.3184 42.2574 41.028 42.9378 42.6417 43.8018L42.6354 43.8113Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1756 45.6767L43.1675 44.1278C44.3752 44.8568 45.6594 45.513 46.7746 46.359C47.1135 46.6556 46.9386 46.731 46.7531 47.1714C46.6005 47.2342 45.7378 46.8749 45.5951 46.8203L43.1819 45.6672L43.1756 45.6767Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7748 47.3238C46.9365 47.3911 47.0441 47.5185 47.1512 47.811C47.3276 48.2878 47.0954 48.4074 46.8181 48.7585C46.528 49.1285 46.636 49.0909 46.1842 49.3936C45.9137 49.5702 45.7075 49.528 45.4094 49.3966C45.2476 49.3292 45.1529 49.1416 45.2486 48.9992L46.3868 47.4903C46.4825 47.3479 46.632 47.2692 46.7843 47.3301L46.7748 47.3238Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.81 47.3335C46.9654 47.4103 47.0792 47.5695 47.1674 47.8079C47.199 47.8842 47.2115 47.9478 47.2176 48.0208C47.5835 47.7844 48.0108 47.1896 47.7191 47.0486C47.4686 46.9079 47.3353 46.901 47.2083 46.8845C47.0528 46.8489 46.8488 47.1115 46.8131 47.3493L46.81 47.3335Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.621 42.7597L36.9635 42.9072C37.1982 43.0098 37.3788 43.1312 37.3628 43.1756L37.2284 43.4987C37.2124 43.5431 36.9998 43.5104 36.7651 43.4078L36.4226 43.2603C36.1879 43.1577 36.0072 43.0363 36.0232 42.992L36.1576 42.6688C36.18 42.615 36.3863 42.6572 36.621 42.7597Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2055 40.2347L36.1094 40.5009C39.7599 42.0308 43.1249 43.4516 43.6416 43.7712L43.6479 43.7617C46.257 45.2395 47.8559 46.8239 49.7277 47.4065C51.0444 47.809 51.6401 47.1896 52.1916 46.4716C53.8526 44.308 55.1328 42.0539 56.1277 39.6494C57.1225 37.2448 57.8572 34.7757 58.1957 32.0541C58.3159 31.1564 58.328 30.2964 57.1105 29.6436C55.3858 28.7188 53.1312 28.7057 50.2471 27.8838L42.6285 24.8447L42.5165 25.114L50.059 28.1019C49.3076 30.863 48.5089 33.5096 47.4502 36.0503C46.3914 38.591 45.063 41.0195 43.6519 43.4888C43.237 43.141 40.8265 42.1688 36.2086 40.2506L36.2055 40.2347Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7741 29.9637C49.0134 32.6358 48.1068 35.2788 46.921 37.8031C46.2591 39.3014 45.429 40.7831 44.6403 42.2237C44.3785 42.6954 44.1072 43.1608 43.8422 43.6166C45.5287 44.5984 47.0714 45.8556 48.7961 46.7804C49.592 47.1775 50.572 47.588 51.3645 47.0043C51.8865 46.5972 52.3682 45.8598 52.7478 45.3156C55.4841 41.4493 57.3592 36.7286 57.9513 32.0276C58.0263 31.4027 58.0629 30.8348 57.6326 30.3251C56.8063 29.4804 55.1877 29.1781 54.0705 28.9511C52.8232 28.733 51.5219 28.4924 50.2972 28.1379C50.227 28.2423 50.1785 28.5404 50.1369 28.664C50.0213 29.0825 49.9024 29.5263 49.771 29.9478L49.7741 29.9637Z",
    fill: "#FEFEFE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4946 39.2587L59.0048 34.4444C59.0177 34.3841 59.1448 34.3593 59.2272 34.4009L60.0862 34.9093C60.1972 34.9701 60.2381 35.0941 60.2221 35.1384L58.7953 39.6643C58.7793 39.7087 58.6776 39.7368 58.5729 39.7078L57.6497 39.4181C57.545 39.3891 57.4722 39.3126 57.4946 39.2587Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5043 48.6285C54.7226 49.8533 55.3192 51.0397 57.2773 50.385C57.9036 50.1719 59.3063 49.4196 60.1636 47.3223C58.986 47.1648 56.1457 47.6125 55.4948 48.6221L55.5043 48.6285Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2689 18.6979L9.85946 19.6768C9.80191 19.8035 9.72861 19.8921 9.6842 19.876L9.57636 19.8311C9.53195 19.815 9.54184 19.6976 9.59938 19.5709L10.0088 18.592C10.0663 18.4653 10.1397 18.3768 10.1841 18.3929L10.2919 18.4378C10.3363 18.4538 10.3264 18.5712 10.2689 18.6979Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1048 13.4819C12.2488 13.1239 12.2847 12.8035 12.1959 12.7714L11.3776 12.4282C11.2793 12.3897 10.7229 12.6221 10.5757 12.9642C9.25314 15.5895 8.31069 17.4642 7.50459 19.403C6.71126 21.3229 6.02563 23.3288 5.09945 26.1241C4.96823 26.4631 5.18566 27.0226 5.28399 27.0611L6.10225 27.4043C6.19107 27.4364 6.38234 27.1929 6.53583 26.8413C7.3144 24.5532 8.11511 22.2938 9.04917 20.0414C9.98323 17.7889 10.9583 15.6192 12.0953 13.4755L12.1048 13.4819Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3647 12.4884C11.1139 12.4715 10.7477 12.7904 10.6296 12.9867C9.72545 14.8045 8.73233 16.6314 7.94863 18.5163C6.8393 20.9679 6.02797 23.5923 5.1502 26.1306C5.11142 26.3526 5.1322 26.8351 5.32222 27.0042L6.13098 27.341C6.50351 27.0125 6.69652 26.1914 6.84713 25.7413C7.62858 23.5517 8.40702 21.3049 9.35022 19.1826C10.1627 17.2343 11.0735 15.3245 12.0318 13.4467C12.1086 13.2502 12.1728 13.0315 12.1639 12.8189L11.3552 12.4821L11.3647 12.4884Z",
    fill: "#FEFEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6895 11.0288C11.5317 9.77566 12.8502 9.55929 14.3375 10.2418L14.5531 10.3316L13.829 12.4771L11.2161 11.231C10.0105 12.9428 8.50866 16.0401 7.19068 19.2335C5.87922 22.3761 4.71674 25.6051 4.34823 27.7553L7.06673 28.7416L6.0476 30.7715L5.84144 30.6881C4.30937 30.1132 3.52512 29.0212 3.82808 27.5435C4.18946 25.6504 5.46327 22.3584 6.81001 19.1017C7.94235 16.3899 9.05316 13.4432 10.6895 11.0288Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8458 47.3018L59.8586 47.2828L59.903 47.2989C59.8871 47.302 59.8712 47.3051 59.8617 47.2987L59.8458 47.3018ZM64.1674 36.9076C64.1769 36.914 64.1959 36.9268 64.2054 36.9332L64.161 36.9171L64.1674 36.9076ZM63.3448 31.6832C63.751 31.777 64.1945 32.1439 64.5669 32.9041C64.8414 33.502 65.3005 34.9956 64.4591 37.0486L64.513 37.071C64.3811 38.7049 63.9313 40.4422 63.1254 42.2985L63.1159 42.2921C63.119 42.308 63.1127 42.3175 63.1063 42.327C63.036 42.4726 62.9816 42.6152 62.9113 42.7609L62.9303 42.7737C62.1847 44.6429 61.2718 46.2068 60.1947 47.4398L60.1313 47.411C59.2645 49.4606 57.8969 50.1814 57.2738 50.4103C56.4695 50.6829 55.8981 50.6296 55.5558 50.3996L54.5444 50.9189C54.7982 50.993 55.0267 51.0638 55.2076 51.1027C57.3307 51.5373 58.9696 51.4397 59.7379 50.4402C61.1851 48.6153 62.6607 45.8035 63.8826 42.8763C63.9083 42.797 63.9434 42.7242 63.9786 42.6513L63.9691 42.6449C65.1399 39.7937 66.0411 36.8714 66.3083 34.6256C66.4676 33.3821 65.3821 32.1428 63.5884 30.9511C63.4267 30.8425 63.2238 30.7337 62.9765 30.6088L63.3289 31.6863L63.3448 31.6832Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7054 27.0103L45.7211 24.1665C44.7092 23.8034 44.0392 23.7941 43.8957 23.9871L43.4557 24.5596C43.3633 24.6766 43.8101 24.9769 44.5301 25.2816L46.0397 25.9103C47.6763 26.5967 49.0435 27.0883 50.0684 27.3498L53.3653 28.1736C54.0856 28.3545 54.6253 28.414 54.6893 28.2366L54.9037 27.6916C54.9485 27.5839 54.2828 27.2192 53.6895 27.0134L53.7054 27.0103Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.564 27.1349L50.7106 26.0038L45.6985 24.2203C45.3433 24.0918 44.9689 23.9918 44.5943 23.933C43.9341 23.8476 43.9336 24.0126 43.5031 24.5915C43.4519 24.7087 44.3081 25.1187 44.4159 25.1636C46.1064 25.8725 47.7936 26.6067 49.5545 27.1286L49.564 27.1349Z",
    fill: "#FEFEFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2784 26.2063L50.1732 27.2964C51.544 27.6388 52.9113 28.0891 54.3016 28.2793C54.7461 28.3162 54.6863 28.1382 54.8623 27.6914C54.7992 27.5388 53.9366 27.1796 53.8002 27.1155L51.2879 26.2126L51.2784 26.2063Z",
    fill: "#FEFEFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9861 27.6095C55.1478 27.6768 55.3098 27.6617 55.5992 27.5392C56.0698 27.3317 55.9784 27.0774 56.0401 26.6366C56.0955 26.1639 56.1492 26.2689 56.0365 25.7384C55.9644 25.4143 55.7964 25.3152 55.4888 25.1774C55.327 25.11 55.1173 25.1757 55.0914 25.3375L54.8158 27.2056C54.7899 27.3674 54.8243 27.5421 54.9766 27.6031L54.9861 27.6095Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0048 27.6222C55.157 27.6832 55.3731 27.6492 55.5989 27.5392C55.6752 27.5078 55.7261 27.4731 55.7834 27.4289C55.8742 27.8482 55.7545 28.5808 55.4437 28.4684C55.1708 28.3815 55.0631 28.2953 54.9585 28.2251C54.8254 28.1356 54.8677 27.8057 55.0048 27.6222Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5885 23.6124L44.931 23.7599C45.1657 23.8625 45.3783 23.8952 45.3943 23.8508L45.5287 23.5277C45.5447 23.4833 45.38 23.3588 45.1294 23.2593L44.7869 23.1118C44.5522 23.0092 44.3395 22.9766 44.3235 23.0209L44.1892 23.3441C44.1668 23.3979 44.3379 23.5129 44.5885 23.6124Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0454 32.8771C62.3672 31.4535 63.6228 31.0433 64.5477 32.8913C64.8475 33.4925 65.2875 35.0146 64.4111 37.0991C63.467 36.3682 61.7878 34.0408 62.0517 32.8677L62.0454 32.8771Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9745 46.8644C60.1935 46.8876 60.3111 46.8564 60.4925 46.7302C60.6071 46.6419 60.7949 46.5062 60.9451 46.18C61.5542 45.3352 62.2761 43.9324 62.8807 42.4783C63.4853 41.0242 63.9312 39.5186 64.1439 38.504C64.2623 38.1839 64.2408 37.949 64.219 37.7965C64.1911 37.5711 64.1216 37.4692 63.9473 37.3383C63.6659 39.0509 63.1275 40.6735 62.513 42.245C61.8729 43.8958 60.8487 45.5226 59.9904 46.8613L59.9745 46.8644Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8459 42.4687C62.6955 42.8362 62.482 43.0923 62.3742 43.0474C62.2663 43.0025 62.2991 42.6662 62.4495 42.2987C62.5998 41.9312 62.8134 41.6751 62.9212 41.72C63.029 41.7649 62.9963 42.1012 62.8459 42.4687Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0764 28.748L33.4829 39.8103",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4827 39.8102C34.3264 40.1567 34.767 40.4252 34.6998 40.5868",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6995 40.5868L34.4756 41.1253",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4761 41.1253C34.4249 41.2426 34.2658 41.3561 33.8437 41.2654",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8428 41.2654L32.0592 40.9211",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0601 40.9212C31.2794 40.7686 31.0446 40.7072 29.5095 40.0753",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5157 40.0658L6.24906 30.3281",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16823 19.2461L9.99093 20.4264",
    stroke: "white",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9683 32.0173L34.5508 42.6364",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8351 12.4675C10.9868 17.6505 8.73167 23.0805 7.05371 28.7605",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10243 28.4212L36.0939 40.5041",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21473 28.1518L36.2062 40.2347",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8354 12.5089L40.2835 23.4476",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2827 23.4475C41.1263 23.794 41.615 23.9294 41.6821 23.7679",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6826 23.7679L41.9097 23.2452",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9102 23.2452C41.9613 23.128 41.9238 22.9374 41.5625 22.6946",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5684 22.6852L40.0631 21.6598",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0629 21.6597C39.4069 21.2189 39.1978 21.0783 37.6627 20.4463",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6722 20.4527L14.3735 10.8037",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17188 19.262L9.98507 20.4359",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6289 32.8505L43.0464 22.2314",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6181 12.7491L42.6095 24.8321",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5067 13.0184L42.4982 25.1013",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6299 47.2945C60.7746 45.7761 61.8372 44.0511 62.7046 41.7952",
    stroke: "white",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M63.996 36.7926C63.7236 38.6767 63.2604 40.6392 62.2598 42.8469",
    stroke: "white",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.214 13.741L8.94531 28.8829L10.3717 29.4743L16.6403 14.3325L15.214 13.741Z",
    fill: "#FEFEFE"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8175 16.0645L14.5488 31.2063L15.9752 31.7978L22.2439 16.6559L20.8175 16.0645Z",
    fill: "#FEFEFE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.421 18.388L20.1523 33.5299L21.5787 34.1213L27.8474 18.9795L26.421 18.388Z",
    fill: "#FEFEFE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0236 20.7116L25.7549 35.8534L27.1812 36.4449L33.4499 21.303L32.0236 20.7116Z",
    fill: "#FEFEFE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6271 23.0351L31.3584 38.177L32.7848 38.7685L39.0534 23.6266L37.6271 23.0351Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBus);
export default __webpack_public_path__ + "static/media/green_bus.51fe11a44f0c765c92c2d263422ad687.svg";
export { ForwardRef as ReactComponent };